// Generated from legacy DB mapping (experience -> cover filename).
export const EXPERIENCE_IMAGE_MAP: Record<number, string> = {
  6: 'img-0i3C62W.jpeg',
  7: 'img-1055r0jT.png',
  12: 'img-0tiMM1c.jpg',
  13: 'img-0mP9er2.jpeg',
  14: 'img-0NnBoO6.jpeg',
  26: 'img-0Gakp28.jpeg',
  30: 'img-0kdRLN4.jpeg',
  54: 'img-0Gg4Qgu.jpeg',
  56: 'img-06hP1Cn.jpeg',
  65: 'img-0ZvBqC2.jpeg',
  66: 'img-0UIEFkj.jpg',
  69: 'img-0u2m9PV.jpeg',
  71: 'img-0BJ81Gr.jpeg',
  72: 'img-0J7Krqo.jpeg',
  75: 'img-05pIzBp.jpeg',
  77: 'img-0SdpRr4.JPG',
  78: 'img-0R1xNjr.jpeg',
  79: 'img-0rapMfN.jpg',
  80: 'img-0P1RZlC.jpeg',
  83: 'img-0BXC3dS.jpeg',
  84: 'img-0IU0HUT.jpg',
  85: 'img-36wobZYB.jpeg',
  103: 'img-0AdHndM.jpeg',
  106: 'img-40vCgTpT.jpg',
  113: 'img-0yplbGm.jpeg',
  115: 'img-43S2bMnf.jpg',
  117: 'img-44Z3lqZc.jpeg',
  118: 'img-09ndkKI.jpeg',
  121: 'img-004Jex1.jpeg',
  122: 'img-0YvwMkE.jpeg',
  123: 'img-0uZn1Ti.jpeg',
  124: 'img-0N15o9H.jpeg',
  125: 'img-0aKFS0x.jpeg',
  126: 'img-0OCeCiY.jpeg',
  127: 'img-03IdCUf.jpeg',
  128: 'img-0p1hB22.jpeg',
  129: 'img-0PwwmHW.jpeg',
  130: 'img-0slzGOS.jpeg',
  131: 'img-0eWGYeT.jpeg',
  132: 'img-0wj8QlY.jpeg',
  133: 'img-0GdckwK.jpeg',
  134: 'img-0160tAo.jpeg',
  135: 'img-040c7d8.jpeg',
  136: 'img-0ydZBP0.jpeg',
  137: 'img-0BYargZ.jpeg',
  138: 'img-0MpHFUI.jpeg',
  139: 'img-0K8nnuh.jpeg',
  140: 'img-0ZClcpB.jpeg',
  141: 'img-0eHEQj8.jpg',
  142: 'img-0uMS7J9.jpg',
  143: 'img-013fZqh.jpg',
  144: 'img-0YZK8Ta.jpeg',
  145: 'img-0Umsxtz.jpeg',
};

export function getMappedExperienceImage(id: number | null | undefined): string | null {
  if (id == null) return null;
  return EXPERIENCE_IMAGE_MAP[id] || null;
}
